<template>
  <div>
    <header-component></header-component>
    <main class="terms-of-service-main">
      <section>
        <h1>訪問支援マッチングサービスアネラ利用規約</h1>
        <hr>
        <p>本訪問支援マッチングサービスアネラ利用規約（以下「本利用規約」といいます。）は、株式会社オムニ（以下「当社」といいます。）と当社の提供する訪問支援マッチングサービスアネラのウェブサイトを利用する利用者（以下「ユーザー」といいます。）との間で、本サイト上で当社が提供するサービス（以下「本サービス」といいます）の利用に関する条件を定めるものです。<br>
        本サイトをご利用いただく前に、本利用規約をよくお読みください。<br>
        ユーザーは、本サイトの利用を開始することにより、本利用規約に同意したものとみなされます。また、本利用規約にご同意いただけない場合は、本サイト及び本サービスをご利用いただけません。</p>

        <p>本利用規約は、当社の都合によりユーザーにあらかじめ通知することなく変更されることがあります。変更後の本利用規約は、別途定める場合を除いて、本サイト上に表示された時点より効力を生じるものとします。ユーザーが、本利用規約の変更後に本サイト又は本サービスを利用したときに、当該変更に同意したものとみなされ、変更後の本利用規約が適用されるものとします。</p>

        <p>なお、本利用規約においては、本サービスをサポーターの療育サービス（以下「療育サービス」といいます。）の提供を受けるために利用するユーザーを「保護者」といい、提供できる療育サービスの内容や療育サービスの提供実績を本サイト上で公開し、保護者に対し療育サービスの提供を行なうために利用するユーザーを「サポーター」といいます。</p>
        
        <section>
          <h2>訪問支援マッチングサービスアネラについて</h2>
          <ol>
            <li>本サイトは、療育サービスの提供者を必要とする保護者にとっては、自らが必要とする療育サービスを提供で きるサポーターを検索することができるサイトであり、サポーターにとっては、自らの療育サービスの提供実績や実際に提供できるサービス内容を掲載することにより、療育サービスの提供機会を増加することができるサイトです。</li>
            <li>保護者がサポーターから療育サービスの提供を受ける場合は、保護者及びサポーターで、別途当該サービスに関する業務委託契約（以下、「療育サービス契約」といいます。）を、当社を介することなく締結する必要があります。当社は、本サイトの運営事業者であり、療育サービスの提供事業者ではありません。そのため、当社は、療育サービス等契約について一切関与せず、また、何らの責任を負うものでもありません。</li>
            <li>保護者及びサポーターは、自らの選択及び責任において療育サービス等契約を締結し、療育サービス等契約に関連して生じた問い合わせ、苦情、請求、紛争等について、保護者及びサポーター間で解決するものとします。当社は、これらの紛争等については、一切責任を負うことなく、また、その解決に関与する義務を負いません。</li>
          </ol>
        </section>
        <section>
          <h2>本サービスの内容</h2>
          <ol>
            <li>当社が本サイト上で、保護者に対して提供する本サービスは以下のとおりです。
              <ol>
                <li>プロフィールの作成ツールの提供及びプロフィールの本サイト上での表示</li>
                <li>サポーターの検索・閲覧</li>
                <li>サポーターへの面談リクエストの送信</li>
                <li>サポーターへの療育サービスの予約・申込ツールの提供</li>
                <li>サポーターへの産後ケアサービスの予約・申込ツールの提供</li>
                <li>サポーターとのコミュニケーションツールの提供</li>
                <li>療育サービスにかかる料金の決済</li>
                <li>レビューの閲覧・書き込みツールの提供</li>
              </ol>
            </li>
            <li>当社が本サイト上で、サポーターに対して提供する本サービスは以下のとおりです。
              <ol>
                <li>プロフィールの作成ツール及びプロフィールの本サイト上での表示</li>
                <li>自身が提供できる療育サービスの掲載</li>
                <li>保護者からのサポーターへの面談リクエストの受信</li>
                <li>保護者からの療育サービス申込み受付及びその承諾ツールの提供</li>
                <li>保護者とのコミュニケーションツールの提供</li>
                <li>レビューの閲覧・書き込みツールの提供</li>
              </ol>
            </li>
            <li>当社は、前二項のユーザーが利用できるサービスを追加、終了することがあります。その場合、当社は本サイト上にサービスを追加又は終了した旨及び当該サービスを利用する方法等を掲載するものとします。</li>
          </ol>
        </section>
        <section>
          <h2>利用要件</h2>
          <ol>
            <li>保護者として利用できる者は、以下の要件を全て満たす者とします。
              <ol>
                <li>これまでに犯罪歴がない者</li>
              </ol>
            </li>
            <li>サポーターとして利用できる者は、以下の要件を全て満たす者とします。
              <ol>
                <li>療育に熱意と理解があり、安全に子供を預かることのできる満20歳以上の健康な者</li>
                <li>保育士、幼稚園教諭、教員、社会福祉士、精神保健福祉士、理学療法士、作業療法士、言語聴覚士、公認心理師等のいずれかの資格を保有する者又は大学(短大を除く)の「社会福祉学」「心理学」「教育学」「社会学」卒業、児童福祉事業に従事した経験が有る者<br></li>
                <li>当社又は当社が委託する第三者による面談に合格した者<br>※面談にて“不適当”と判断された場合は登録を認めません。</li>
                <li>これまでに犯罪歴がない者</li>
                <li>登録完了後においても当社又は当社が委託する第三者による活動状況等の定期的なヒアリングに協力できる者</li>
              </ol>
            </li>
            <li>当社は、任意に利用要件を変更することができるものとし、変更した場合は本サイト上に表示するものとします。</li>
          </ol>
        </section>
        <section>
          <h2>登録</h2>
          <ol>
            <li>登録を希望する者は、自己のメールアドレスを入力し、本サイト所定の事項（サポーターは、特定商取引に関する法律第11条に定める表記を含みます。）を記載の上登録を申込むものとします。なお、住所は、登録を希望する者の自宅の住所を記載する必要があります。</li>
            <li>当社が、本サイト上に登録希望者の情報掲載を開始した時点で、当該登録希望者の登録申込みを承認したものとし、ユーザー登録が完了します。</li>
            <li>登録を希望する者は、当社又は当社が委託する第三者に対して、前項の申込みの後速やかに、当社が指定する本人確認書類を提出しなければなりません。登録を希望するサポーターは、①資格を有することを証明する書類、②身分証明書を提出する必要があります。</li>
            <li>サポーターとして登録を希望する者が登録時に入力した情報のうち、氏名、居住エリア、顔写真のサムネイル画像、年代、療育経験等のプロフィールについては、本サイトに登録した保護者だけでなく他のサポーターも閲覧することができます。サポーターとして登録を希望し、登録を申込んだ者は、これについて同意したものとみなします。</li>
            <li>登録時又は登録後に保護者が設定した又は自動的に設定された保護者自身のプロフィール用の顔写真のサムネイル画像は、サイト上に表示されます。保護者として登録を希望し、登録を申し込んだ者は、これらについて同意したものとみなします。</li>
            <li>当社は、ユーザーの身元調査を行なう義務を負わないものとし、ユーザーが登録要件を満たしていること及びユーザーの登録内容が正確、真実又は最新であることを保証するものではありません。</li>
            <li>前項にかかわらず、当社は任意に、いつでも、ユーザーに対し、子供に関する情報書類等その他登録に必要となる情報に関連して当社が要請した書類（以下「提出書類等」といいます。）の提出を要請することができ、ユーザーはこれに応じるものとします。</li>
            <li>当社は、本サイトのツールを使用して締結かつ決済された療育サービス等契約に基づき、本利用規約に違反することなくサポーターにより提供された療育サービスに適用される保険に加入しています。サポーターは、登録が完了した時点で、当社が加入する保険の被保険者となりますので、当社の要請に基づいて必要な手続き又は資料の提出をお願いすることがあります。なお、当該保険の保険料は、第8条記載の月会費等に含まれます。</li>
            <li>当社は、登録を行なう者が以下に定める事由のいずれかに該当すると判断した場合、登録を拒否することができるものとします。なお、当社は、当該拒否について一切の責任を負わず、また拒否理由を説明する義務を負わないものとします。
              <ol>
                <li>登録要件を満していなかった場合</li>
                <li>本利用規約に違反する行為を行なうおそれがある場合又は過去に違反した事実が判明した場合</li>
                <li>登録時に当社に提供された情報に虚偽の記載や記載漏れがあった場合</li>
                <li>本人確認書類又は資格を有することを証明する書類を提出期限までに提出しなかった場合又は提出した提出書類に虚偽の内容が含まれていた場合</li>
                <li>当社が要請するその他の提出書類等を提出期限までに提出しなかった場合又は提出した提出書類等に虚偽の内容が含まれていた場合</li>
                <li>登録された連絡先（メールアドレス、電話番号等）への問い合わせに対し７日以上返事がなかった場合</li>
                <li>前項の保険の被保険者となれなかった場合</li>
              </ol>
            </li>
            <li>当社は、登録が完了したユーザーに対して、会員証並びにIDを発行し、ユーザーはパスワード（以下、会員証、ID及びパスワードを総称して「ID等」といいます。）を設定します。</li>
            <li>ユーザーは、当社が発行するID等を厳重に管理する義務を負うものとし、第三者に使用させることはできず、また、譲渡、貸与、開示等をしてはならないものとします。</li>
            <li>当社は、ユーザーに発行されたID等を使用して行われた行為について、当該ユーザーの行為とみなすことができるものとし、ユーザーは当該行為について責任を負うものとします。</li>
            <li>ユーザーは、自己のID等の不正使用を発見した場合、直ちに、当社に通知し、これを是正するための合理的努力をするものとします。</li>
            <li>ユーザーは、自己のID等の不正使用によって、当社又は第三者（他のユーザーを含み、以下同様とします。）に損害が生じた場合、当社又は第三者に対してその損害を賠償するものとします。</li>
            <li>ユーザーは、登録の内容に変更が生じたときは（資格若しくは免許の取消し、又は資格若しくは免許を使用した業務の停止処分等が生じたときを含むが、これらに限られません。）、速やかに、登録変更を行わなければなりません。ユーザーは、登録変更を行わないことにより、ユーザー自身、当社又は第三者に生じた損害について責任を負うものとします。なお、ユーザーは、資格や免許の取消し、業務停止処分等が生じたときは、その旨を当社に通知しなければなりません。</li>
            <li>ユーザーは、資格や免許の取消し、業務停止処分等が生じたとき、その旨を当社に通知しなければなりません。</li>
          </ol>
        </section>
        <section>
          <h2>療育サービス内容</h2>
          <ol>
            <li>サポーターが提供する療育サービスの内容は、次に掲げるものとします。
              <ol>
                <li>保護者の病気、通院、就業等の事情により、一時的に保護者の子供を預かること。</li>
                <li>療育所、幼稚園等への送迎を行なうこと。</li>
                <li>その他本サイト上に記載する療育サービス</li>
                <li>上記に付随して必要と認められる業務。</li>
              </ol>
            </li>
            <li>サポーターが療育サービス提供中に保護者の子供に食事又は間食を食べさせなければならない場合、保護者がその食事又は間食を準備するものとし、サポーターは食事又は間食を準備することはできません。</li>
            <li>療育サービスの提供は、原則として保護者の住居、またはサポーターが提供する療育場所において行なうものとします。療育サービスの提供が他の場所で行われる場合は、サポーターは事前に療育場所を見学し確認するものとします。</li>
            <li>療育サービスの提供にあたっての子供の受け渡しは、必ず保護者に対して直接又は緊急連絡先ご登録者、療育園関係者等を通じて行われるものとし、これらの者が不在の場合は、受け渡しを行なうことはできません。</li>
            <li>サポーターは、同じ保護者の子供複数名に同時に療育サービスを提供することはできますが、異なる保護者の子供に対し、同時に療育サービスを提供してはなりません。</li>
            <li>療育サービス契約において、療育サービスの契約時間は、面談のみの場合は15分以上（1時間未満の場合でも基本料は1時間分かかります）、面談及び療育（または療育のみ）の場合は1時間以上にしなければならず、1回の契約時間が1時間を超える場合、以後15分ごとに時間を設定することができるものとします。</li>
            <li>療育サービスの提供時間の計測は、次のとおりとします。
              <ol>
                <li>子供を保護者の住居において預かる場合（本条第2項の場合を含みます）は、サポーターが当該住居に到着したときから、退去したときまで</li>
                <li>療育所等への送迎の場合は、サポーターが子供を預かったときから、療育所等に送り届けたときまで、または、サポーターが子供を療育所等から預かったときから保護者へ引き渡したときまで</li>
              </ol>
            </li>
            <li>サポーターは、療育サービスの提供時間中、保護者が求める場合は、療育に支障がない範囲で、子供の状況を電話、メール等の手段にて報告するものとします。</li>
            <li>サポーターは、療育サービスの提供時間中、子供に事故や体調の急激な悪化等の緊急事態が発生した場合は、保護者に対して直ちに連絡し、救急医療の手配等の適切な対応をとるものとします。火災や地震などの災害発生時における子供の引渡し方法などについては療育開始前もしくは療育開始時にサポーターと保護者との間であらかじめ確認しておくものとします。</li>
            <li>保護者及びサポーターは、療育サービスの提供時間中、当社の指定する者が療育場所を巡回することがあることを了解し、療育状況等の確認を求められた場合は対応するものとします。</li>
            <li>療育サービス終了後（子供の引き渡し時）に、サポーターは保護者に対して療育サービス提供時間中の子供の状況を報告するものとします。</li>
          </ol>
        </section>
        <section>
          <h2>療育サービス等契約</h2>
          <ol>
            <li>保護者は、初めて依頼するサポーターから療育サービスの提供を受けたいときは、事前に当該サポーターに、面談依頼をするものとします。保護者は、療育サービスの対象となる子供を必ず面談に同席させなければならないものとします。</li>
            <li>サポーターは、保護者からの面談依頼に基づいて、面談するか否かを判断し、その判断を保護者に通知するものとします。</li>
            <li>保護者及びサポーターは、面談を行った上で、療育サービス契約を締結するか否かをそれぞれ自由に判断することができるものとし、面談の実施が療育サービス契約の締結を約束するものではありません。</li>
            <li>面談は、原則として保護者の住居（療育場所）において行なうものとします。面談にかかる費用は各自の負担となります。</li>
            <li>個々の療育サービス契約は、保護者が、サポーターとの面談後、本サイト上で所定の必要事項を入力の上、療育サービス契約の申込みを行い、サポーターが、当該申込みを承諾した時点で成立するものとします。</li>
            <li>サポーターは、療育サービス契約の締結に際しては、保護者に対し、氏名、住所及び連絡先を伝えます。また、保護者からの希望がある場合には以下の書類を提示するものとします。</li>
              <ol>
                <li>事業停止命令等を受けたことがないこと等を申告する書類</li>
                <li>サポーター保険（賠償責任保険）への加入書類</li>
              </ol>
            <li>療育サービス等契約成立後、保護者が当該契約をキャンセルする場合、以下のキャンセル料をサポーターに支払うものとします。
              <ol>
                <li>療育サービスの開始予定時間から起算して48時間前までにキャンセルする場合、キャンセル料は無料です。</li>
                <li>療育サービスの開始予定日時から起算して24時間以上48時間未満までにキャンセルする場合は、キャンセル料は交通費以外の利用料（基本料、システム利用料）の50％をいただきます。</li>
                <li>療育サービスの開始予定日時から起算して2時間以上24時間未満にキャンセルする場合は、キャンセル料は交通費以外利用料の100％をいただきます。</li>
                <li>サービス開始予定時間から起算して2時間未満のキャンセルについては、予約確定時にサポーターから申請のあった交通費を上記キャンセル代に加算いたします。</li>
              </ol>
            </li>
          </ol>
        </section>
        <section>
          <h2>療育サービスの記録</h2>
          <ol>
            <li>サポーターは、療育サービスの提供を終了した後速やかに（遅くとも翌日までに）、療育サービス等の記録（以下、個別に又は総称して「サービス記録」といいます。）を本サイト上の所定のフォーマットに記載するものとする。</li>
            <li>保護者は、サポーターが記載したサービス記録を確認し、その内容に誤りがあれば、当該記録の送付から24時間以内にコミュニケーションツール（第10条で定義されます。）にてサポーターに通知し、誤りがない場合は、承認するものとします。保護者の承認によって、療育サービスの提供時間が確定します。療育利用料（次条で定義します。）は、当該確定した療育サービス提供時間を基に計算されます。また、保護者から24時間以内に通知又は承認がない場合、サービス記録の内容に誤りはないものとみなされ、療育サービスの提供時間が確定します。</li>
          </ol>
        </section>
        <section>
          <h2>利用料</h2>
          <ol>
            <li>保護者は、療育サービスを受けた場合、サービス記録に記載された療育サービス提供時間に応じて、サポーターに対し、療育サービスの利用料（以下、それぞれを「基本料」といいます。）を支払わなければなりません。各利用料は、各サポーターが各自で定める30分当たりの金額（源泉徴収税及び消費税込）と療育サービス提供時間をそれぞれ積算した金額となります。また、保護者は、サポーターが各サービスの提供に際して費やした費用（交通費、各サービスに関連して保護者の依頼に基づいてサポーターが立替えた費用等を含みます。以下「実費」といいます。）、そして本サイト利用料（療育利用料の10%）を別途支払う必要があります。</li>
            <li>サポーターは、30分当たりの療育利用料（源泉徴収税及び消費税込）を600円以上の範囲内で設定することができます。</li>
            <li>サポーターは、本サービスの利用について、以下の利用料（税込。以下「サイト利用料」といいます。）を当社に支払うものとします。なお、本サイト利用料は、保護者及びサポーター間で締結した療育サービス等契約に基づいて保護者からサポーターに支払われる療育利用料を基に算出されます。
              <ol>
                <li>月会費 無料</li>
                <li>本サイト利用料 療育利用料の10%</li>
              </ol>
            </li>
          </ol>
        </section>
        <section>
          <h2>利用料の支払い</h2>
          <ol>
            <li>保護者は、当社に対し、療育利用料及び実費をクレジットカードにて支払うものとします。当社は、療育サービス提供後、療育利用料及び実費の支払いを保護者のクレジットカード会社に請求します。</li>
            <li>当社は、毎月月末日までに確定した療育サービス時間にかかる療育利用料から、前条3項に定める本サイト利用料を控除し、サポーターに対して、その翌月15日までに、サポーターが指定する口座に振込んで支払うものとします。なお、振込手数料はサポーターの負担とします。当社からの当該支払により、保護者からサポーターへの療育利用の支払いは完了するものとします。</li>
            <li>当社は、保護者による療育利用料の未払いについて何ら責任を負うものではなく、保護者からの支払いがない場合、サポーターは療育利用料を受領することができません。</li>
            <li>保護者のクレジットカードによる決済が1回でもできなかった場合、当社は、保護者による本サービスの利用を終了させることができるものとします。</li>
            <li>サポーターが理由の如何を問わず、保護者に療育利用料を返金した場合であっても、当社は、受領した本サイト利用料の返金に応じる義務を負わないものとします。</li>
            <li>午前8時以前及び午後10時以降の療育サービスについては、療育利用料に25％の早朝又は深夜割増が加算されます。</li>
            <li>療育サービス提供開始時間を過ぎてから、予定療育時間数を超過することが判明した場合は、その超過時間数に対して療育利用料に25％の延長割増が加算されます</li>
          </ol>
        </section>
        <section>
          <h2>コミュニケーションツール</h2>
          <ol>
            <li>当社は、本サイト上に保護者とサポーターが相互にメッセージを送信することができるコミュニケーションツールを提供します。</li>
            <li>当社は、当社が次の各号に該当すると判断する場合、ユーザーへの事前告知なしに、ユーザーによるコミュニケーションツール上のメッセージを閲覧、非公開、削除又は当社が適切だと判断する第三者に開示することができるものとし、ユーザーは本サイト又は本サービスの利用の開始によりこれに同意したものとみなされます。
              <ol>
                <li>法令に基づく強制力のある処分又は命令があった場合</li>
                <li>他人の生命、身体、財産または名誉、プライバシーの保護のために必要があると当社が判断した場合</li>
                <li>ユーザーの同意がある場合</li>
                <li>本サービスの適切な運営上に必要があると当社が判断した場合</li>
              </ol>
            </li>
          </ol>
        </section>
        <section>
          <h2>レビュー</h2>
          <ol>
            <li>保護者は、実際に療育サービスの提供を受けたサポーターについて、当該各サービスの提供後速やかに（遅くとも3日以内に）コメント（以下「本コメント」といいます。）を本サイト上に設けられたレビュー欄に投稿するものとします。投稿された本コメントには、本コメントを投稿したユーザーのイニシャルが表示されます。また、投稿された本コメントは、本サイトに登録したユーザーであれば誰でも閲覧できます。</li>
            <li>当社は、ユーザーが投稿した本コメントが、ユーザーへのヒアリング等を踏まえ本利用規約に抵触する若しくは実態に即していないと判断した場合、ユーザーへの事前通知なく、当該本コメントを削除し、又は当該ユーザー若しくは第三者が当該本コメントを閲覧できないようにすることができるものとします。当社は、コメントの削除又は閲覧不可にすることによりユーザーに生じる損害について、一切責任を負わないものとします。</li>
          </ol>
        </section>
        <section>
          <h2>ユーザーへのお知らせ</h2>
          <ol>
            <li>当社は、ユーザーに対して、おすすめサポーター情報又は本サイトの更新情報を含む本サイト若しくは本サービスに関連する情報を定期的に又は不定期に提供します。ユーザーは登録により当該提供に合意したものとみなされます。</li>
            <li>ユーザーは、これらの情報の提供が不要な場合、本サイト上で停止する手続きを取ることができます。</li>
          </ol>
        </section>
        <section>
          <h2>知的財産権</h2>
          <ol>
            <li>ユーザーは、自ら著作権等の必要な知的財産権を有する、又は必要な権利者（以下「本コメントの権利者」といいます。）の許諾を得た本コメントのみを、レビュー欄に投稿することができるものとします。</li>
            <li>ユーザー（又は本コメントの権利者）は、本コメントの著作権を含む知的財産権を従前どおり保持するものとします。ただし、当社は、本コメントを、本サービスの提供、本サイト又は本サービスの広告宣伝又はプロモーションを目的とする範囲内において、当社が必要と判断する処理を行った上で、本サイト及び当社と提携するサイト等において利用できるものとします。ユーザーは、本項に基づく当社の本コメントの利用について、著作者人格権を行使せず、本コメントの権利者との間で当社の当該利用について著作者人格権を行使しない旨の取り決めを行なうものとします。</li>
            <li>当社は、ユーザーが本サイトから退会した場合又は理由のいかんを問わずユーザーの登録が削除された場合であっても、当該ユーザーが投稿した本コメントを前項ただし書に記載する方法で継続して利用することができるものとします。</li>
            <li>ユーザーが投稿した本コメントを除き、本サイトそのもの、本サイト及び本サービスに関連する一切の情報についての著作権、訪問支援マッチングサービスアネラ又は本サービスの商標及びその他の知的財産権は、すべて当社又は当社にその利用を許諾した権利者に帰属します。ユーザーは、これらについて複製、譲渡、貸与、翻訳、改変、転載、公衆への送信（公衆への送信を可能とすることを含みます。）、転送、配布、出版、営業のための使用等をしてはならないものとします。</li>
          </ol>
        </section>
        <section>
          <h2>個人情報</h2>
          <ol>
            <li>当社は、ユーザーの個人情報その他のプライバシー情報を、別途定めるプライバシーポリシー（以下「プライバシーポリシー」といいます）に従って適切に取り扱います。</li>
            <li>ユーザーは、本サービスの利用により知り得た他のユーザーの個人情報又は家庭の事情等を療育サービス等契約の締結又は当該契約の履行目的のみに使用することができるものとし、当該情報を第三者に開示、提供又は漏洩してはなりません。</li>
          </ol>
        </section>
        <section>
          <h2>サービスの停止、終了、登録の削除等</h2>
          <ol>
            <li>当社は、次の各号に該当する場合には、ユーザーに対する事前通知なしに、本サービスの提供を一時的に停止することができるものとします。当該一時停止により、ユーザーに損害が生じたとしても当社は何ら責任を負わないものとします。
              <ol>
                <li>本サービスにかかるサーバーの保守、本サイトの障害復旧若しくは定期メンテナンス、又は本サービスについて仕様変更若しくは本サービスの瑕疵の修補等を行なう場合</li>
                <li>天災地変その他非常事態が発生し、若しくは発生するおそれがあり、又は法令等の改正、成立により本サービスの運営が困難又は不可能になった場合</li>
                <li>その他当社がやむを得ない事由により本サービスの運営上一時的な停止が必要と判断した場合</li>
              </ol>
            </li>
            <li>当社は、ユーザーが以下のいずれかの事由に該当する場合、当該ユーザーに何ら通知することなく、当該ユーザーの本サービスの一部又は全部の利用を一時停止すること、又は当該ユーザーの登録を削除し、退会させることができるものとします。ただし、当社は、当該停止又は退会処分について生じたユーザーの損害に対して一切の責任を負いません。
              <ol>
                <li>ユーザーが本利用規約に違反した場合</li>
                <li>ユーザーの登録情報、メッセージ又は本コメントが第三者を侮辱、中傷し若しくは嫌悪感を与える表現、又は公序良俗に反する表現を含んでいる場合</li>
                <li>ユーザーが反社会的勢力等（暴力団、暴力団員、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロ又は特殊知能暴力集団等その他これらに準ずる者をいいます。以下、同様とします。）に該当する、又は資金提供その他により反社会的勢力等の維持、運営に協力若しくは関与していると当社らが判断する場合</li>
                <li>ユーザーが3か月以上本サイトにアクセスしていない場合</li>
                <li>1年以上ユーザーによる本サービスの利用がない場合</li>
                <li>サポーターがその保有する資格を喪失し、免許を取り消され、又は、資格若しくは免許に基づく業務の停止処分等が行われた場合、及び当社連絡後1ヶ月以上返信のない場合</li>
                <li>ユーザーが登録要件を具備しなくなった場合</li>
                <li>その他ユーザーによる本サービスの利用が不適切であると当社が判断する場合</li>
              </ol>
            </li>
            <li>ユーザーは、自ら登録を削除し、退会したい場合、当社の定める方法に基づき削除、退会することができます。</li>
            <li>当社は、ユーザーの登録が理由のいかんを問わず削除された後も、当該ユーザーに関する情報（個人情報、本コメント及び本サービス利用に関連する情報を含むがこれらに限られない。）を保持することがありますが、当該情報保持の継続について何ら義務を負うものではありません。</li>
          </ol>
        </section>
        <section>
          <h2>本サイト・本サービスの変更等</h2>
          <ol>
            <li>当社は、当社が必要と判断した場合には、ユーザーに通知することなく、いつでも本サイト又は本サービスを変更、停止、中止又は終了することができるものとし、これらにより、ユーザーに生じた不利益又は損害について、一切責任を負わないものとします。</li>
            <li>本サイト又は本サービスが変更、停止、中止又は終了した場合であっても、これらの事象が生じる前にユーザー間で成立した療育サービス等契約は何ら影響を受けないものとします。</li>
          </ol>
        </section>
        <section>
          <h2>第三者のサービス</h2>
          <ol>
            <li>本サイトにおいて、第三者のウェブサイトへのリンクを提示されることがあります。ユーザーが、これらの第三者アプリ等を利用する場合、当該第三者の利用規約及びプライバシーポリシーに従い、自らの責任でこれを利用するものとします。これらの第三者アプリ等及び第三者アプリ等で提供される製品及びサービス、又は第三者の作為若しくは不作為については、これを提供する第三者たる事業者が責任を負い、当社は一切の責任を負いません。</li>
            <li>第三者のウェブサイトが、当社の承諾の有無を問わず、本サイトへのリンクを提供することがあります。当社は、これら第三者のウェブサイトに関連してユーザーが被った損害について責任を負いません。</li>
          </ol>
        </section>
        <section>
          <h2>地位譲渡</h2>
          <ol>
            <li>ユーザーは、当社の書面による承諾がなければ、本利用規約上の地位又は本利用規約に基づき生ずる権利義務について、第三者に対して譲渡、移転、担保設定又はその他の処分をすることができません。</li>
            <li>ユーザーは、療育サポート等契約の相手方の書面による承諾がなければ、療育サポート等契約に関する契約上の地位又は当該契約により生じる権利義務について、第三者に対して譲渡、移転、担保設定又はその他の処分をすることができません。</li>
            <li>当社は、本サービスにかかる事業を他社に譲渡する場合、当該事業譲渡に伴い本利用規約上の地位、本利用規約に基づき生じる権利義務及びユーザーから本サービス利用に関して取得した全ての情報を当該事業譲渡の譲受人に譲渡することができるものとし、利用者は、かかる譲渡につき予め同意するものとします。なお、本規定における事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。</li>
          </ol>
        </section>
        <section>
          <h2>禁止事項</h2>
          <ol>
            <li>ユーザーは、法令を遵守し、第三者の権利及び尊厳を尊重することとします。ユーザーは以下に記載する不正行為を行わないことに同意します。
              <ol>
                <li>本サイトの利用に関し、以下について投稿、送信、又は利用可能にする行為
                  <ol>
                    <li>以下に該当し得る素材
                      <ol>
                        <li>刑事上又は民事上の責任を生じさせるもの</li>
                        <li>犯罪行為となり得る行為を助長するもの</li>
                        <li>違法行為又はハッキング、クラッキング、フリーキングといった行為を助長又はその方法を紹介する情報を提供するもの</li>
                      </ol>
                    </li>
                    <li>ウイルス、ワーム、トロイの木馬、イースターエッグ、時限爆弾、スパイウェアその他の以下のようなコンピューターコード、ファイル又はプログラム
                      <ol>
                        <li>潜在的に有害又は侵略性のあるもの</li>
                        <li>ハードウェア、ソフトウェアその他の機器の操作に損害を与え若しくは乗っ取ることのできる、又はこれを意図するもの</li>
                        <li>ハードウェア、ソフトウェアその他の機器の使用を監視することのできる、又はこれを意図するもの</li>
                      </ol>
                    </li>
                    <li>未承諾広告、宣伝資料、ジャンクメール、スパム、チェーンレター、マルチ商法若しくは投資機会その他勧誘</li>
                  </ol>
                </li>
                <li>本サービスの利用に関し、自ら又は第三者のために不正な利益を得ようとする行為</li>
                <li>不正行為を行なうソフトウェア、自動ソフトウェア、ボット、ハック、無断改変（モッズ）その他の許可されていない第三者のソフトウェアを作成する又は作成を助ける意図で本サイトを利用する行為</li>
                <li>中傷、悪用、嫌がらせ、付きまとい、脅しその他の第三者の法的権利（プライバシー権又は肖像権を含みますがこれらに限られません。）を害するため、又はユーザーを特定する個人情報を収集するために本サービスを利用する行為</li>
                <li>本サイト又は本サイトを提供するためのサーバーやネットワークの運営を妨害する行為<br>
                この行為には不合理又は不均衡に大きな負荷を本サイト、本サイトのためのサーバー若しくはネットワークにかけること、又はこれらのネットワークの要件、手続き、ポリシー、規則に違反することを含みます。</li>
                <li>ハッキングや本サイトの一部を書き換えること等により、第三者が本サイトを利用することを制限又は阻害する行為</li>
                <li>本サイトのいかなる部分においても、修正、改変、翻案の創作、翻訳、リバースエンジニアリング、逆コンパイル又は逆アセンブルをする行為</li>
                <li>本サイト又は本サイトに由来する素材に表示されている著作権、商標その他の財産権の表示を削除する行為</li>
                <li>当社の事前の書面による承諾なしに、本サイトのいかなる部分であれフレーム又はミラーを作成する行為</li>
                <li>本サイト上で又は本サイトを経由してシステムにより情報及び素材をダウンロードし、保持することによってデータベースを作成する行為</li>
                <li>当社の事前の書面による承諾なしに、本サイト上で若しくは本サイトを経由して利用可能な情報及び素材を取り出し、インデックスを作成し、抽出（スクレイプ）し、データマイニングその他の方法で収集するため、又は本サイトのナビゲーション構造若しくは表示を回避し又は複製するために、ロボット、スパイダー、サイト検索・解析アプリケーションその他手動又は自動の装置を利用する行為</li>
              </ol>
            </li>
            <li>前項に加えて、当社は、本サービスの利用について、ユーザーの故意・過失を問わず、以下の各項に該当すると当社が判断する行為を禁止します（これらの行為は、ユーザーの本サイトのいかなるサービス・機能を利用してなされかにかかわらず、禁止されます。）。
              <ol>
                <li>反社会的行為
                  <ol>
                    <li>法令又は公序良俗に違反する行為</li>
                    <li>犯罪行為又はこれを予告、関与、助長する行為</li>
                    <li>虚偽又は誤解を招くような内容を含む情報等を掲載、登録する等の行為</li>
                    <li>通常利用の範囲を超えてサーバーに負担をかける行為、及びそれを助長するような行為、その他本サイトの運営・提供又は他のユーザーによる本サイトの利用を妨害し、又はそれらに支障をきたす行為</li>
                    <li>第三者の知的財産権（特許権、商標権、著作権及び企業秘密等）を侵害する行為</li>
                    <li>第三者の信用若しくは名誉を侵害し、又は第三者のプライバシー権、肖像権その他一切の権利を侵害する行為</li>
                    <li>自殺、自傷行為、薬物乱用等を美化・誘発・助長するおそれのある言葉、その他の表現の掲載行為</li>
                    <li>ストーキング行為を行なう等、方法のいかんを問わず、第三者に対する嫌がらせ又は第三者を中傷する行為</li>
                    <li>民族・人種・性別・年齢等による差別につながる表現の掲載行為</li>
                  </ol>
                </li>
                <li>わいせつ・暴力的表現・出会い目的行為
                  <ol>
                    <li>モザイク、ぼかしの有無、美術性にかかわらず、下着姿を含む露出度の高いヌード、胸や臀部等のアップや性器が露出した写真等、その他卑猥と判断される画像・映像（動画）・イラスト・絵画の掲載、及び性行為や性器に該当する言葉、その他わいせつ的な表現の掲載行為</li>
                    <li>暴力的、グロテスクな写真、及びその他一般ユーザーが不快に感じる画像、言葉等、その他の表現の掲載行為</li>
                    <li>本サイト内での性行為表現、又はそれを意図した表現の掲載行為</li>
                    <li>リンクを張る等して、アダルトサイトに誘導する行為</li>
                    <li>児童買春・ポルノ、無修正ビデオ映像のダウンロードサイト等へのリンク掲載行為</li>
                    <li>本サイトを使ってアダルト関係の商品について紹介する行為</li>
                    <li>異性との出会い等を希望、又は誘導することが主目的であると当社らが判断する一切の行為</li>
                    <li>その他、未成年者の人格形成等に悪影響を与えると判断される行為（刺青・未成年者の飲酒、喫煙等）</li>
                  </ol>
                </li>
                <li>商業行為
                  <ol>
                    <li>ユーザーが、本サイトを通じて入手した全ての情報及び本サイトに登録したことによって知り得た当社、当社が提供する本サービスに関連する情報について、療育サービス等契約の締結又は当該契約の履行目的以外に、複製、販売、出版、公開その他の方法で使用する行為、第三者へ開示、漏洩する行為、また、ユーザー以外の第三者をして同様の行為をさせる行為</li>
                    <li>当社が許可したものを除き、営利又は非営利目的を問わず、療育サービス又は産後ケアサービス以外のサービスや物の売買、交換、宣伝、勧誘、提供を目的とする情報の掲載</li>
                    <li>次に掲げる内容の情報を、掲載又は送信する行為
                      <ol>
                        <li>ねずみ講、チェーンメッセージ、ＭＬＭ（マルチレベルマーケティング）、等の第三者を勧誘する内容の情報</li>
                        <li>アフィリエイトや招待することでポイント等の利益が発生するサイトへ誘導する情報（ただし、当社が認めるものを除きます。）</li>
                        <li>情報商材を含む情報</li>
                        <li>営利・非営利を問わず、全ての医療及び医療類似行為（その形態において薬剤の利用、スピリチュアル、パワーストーン、カウンセリング、占い行為、等を問いません。ただし、当社が許可したものを除きます。）</li>
                        <li>他のユーザーの個人情報を収集、蓄積する行為、又はこれらの行為をしようとすること</li>
                      </ol>
                    </li>
                  </ol>
                </li>
                <li>個人情報掲載行為
                  <ol>
                    <li>当社が要請した場合以外で、本人、第三者の如何を問わず個人のメールアドレス、電話番号、ナンバープレート、金融機関口座番号、住所等個人を特定しうる情報の掲載行為</li>
                    <li>虚偽の情報（名前、生年月日、メールアドレス、住所等の個人情報を含みます。）を掲載、登録すること</li>
                  </ol>
                </li>
                <li>その他
                  <ol>
                    <li>本サイトのツールを使用することなく、直接ユーザー間で療育サービス等契約を締結すること、または締結しようとサポーターまたは保護者に働きかける行為</li>
                    <li>第三者になりすます行為</li>
                    <li>本利用規約記載の範囲を超えて療育サービスの提供又は利用を行なう行為</li>
                    <li>実際にサービスを受けていないサポーターに対して本コメントを投稿する行為</li>
                    <li>政治活動、宗教活動行為</li>
                    <li>違反行為により本サービスの利用を停止又は登録を削除されたユーザーが再度本サイトを利用する行為</li>
                    <li>自己のID等を第三者に利用させる又は譲渡する行為</li>
                    <li>１つのID等を複数人で利用する行為</li>
                    <li>１人で複数のID等を保有する行為</li>
                    <li>療育サービスの使用に必要のない当社又は本サービスに関する情報を取得しようとする行為</li>
                    <li>本サイトを利用して、反社会的勢力等の活動を助長又は反社会的勢力等に直接的若しくは間接的に利益を供与する行為</li>
                    <li>その他、当社が、合理的な理由に基づき不適切と判断する行為</li>
                  </ol>
                </li>
              </ol>
            </li>
          </ol>
        </section>
        <section>
          <h2>第三者との紛争</h2>
          <ol>
            <li>ユーザーの本サービスの利用につき、ユーザーと第三者との間で紛争が起こった場合、紛争の当事者であるユーザーの責任及び費用負担で当該紛争を解決するものとします。当該紛争により又はこれに関連して当社及び第三者（他のユーザーが当該紛争の相手方の場合、当該他のユーザーを除きます。）が損害を被った場合には、当該ユーザーが単独で、又は当該紛争の相手方の他のユーザーと連帯してこれを賠償するものとします。</li>
            <li>ユーザーは、ユーザーが本コメントに起因又はこれに関連して生じた全ての請求（ユーザーが本利用規約に違反したこと又は第三者の権利を侵害したことに関する請求を含みます。）について、ユーザーの責任と費用負担で解決するものとします。</li>
            <li>ユーザーにより第三者の権利の侵害があったときに、第三者からのクレームや請求に関して当社に賠償金、その他の費用が発生した場合、紛争の当事者である当該ユーザーが、当該賠償金その他の費用等（弁護士費用を含みます。）を負担するものとします。</li>
            <li>紛争（トラブル）の内容について個人情報に留意しつつ、紛争に係るユーザー（保護者及びサポーター）の意向を踏まえたうえで情報公開します。</li>
          </ol>
        </section>
        <section>
          <h2>ユーザーへの情報提供及び都道府県への報告</h2>
          <ol>
            <li>ユーザー（保護者及びサポーター）が不適切な行為を行った等の事案を把握した場合は、個人情報に十分留意した上で全ユーザーもしくは該当ユーザーへの情報提供を行います。</li>
            <li>過去の利用に係るユーザー（保護者及びサポーター）に対する苦情や紛争（トラブル）等に関する情報について集約し、個人情報に十分留意した上で全ユーザーもしくは該当ユーザーへの情報提供を行います。</li>
          </ol>
        </section>
        <section>
          <h2>法の可分性</h2>
          <p>本利用規約の条項が、法令に抵触すると判断された場合又はいずれの当事者との関係においても法的拘束力を有しないと判断された場合、当該条項は、当該法令に抵触し又は法的拘束力を有しないと判断された限度で無効とみなされるものとし、本利用規約の他の全ての条項は有効に存続するものとします。</p>
        </section>
        <section>
          <h2>免責</h2>
          <ol>
            <li>本サイトは、現状有姿のまま提供されるものとします。当社は、明示的か黙示的かを問わず、本サイトを含む本サービスについて、以下の事項を含む、いかなる事項（権利の瑕疵の担保責任、物の瑕疵の担保責任、特定目的適合性及び権利侵害のないことの保証を含みます。）に関して保証するものではありません。
              <ol>
                <li>本サイトが中断しないこと又はエラーがないこと。</li>
                <li>本サイトの障害、又は本サイトの操作若しくは通信に関するエラー、省略、中断、消去、欠陥、運営や送信の遅延、通信回線障害がないこと。</li>
                <li>本コンテンツの盗用、毀損又は改ざんがないこと。</li>
                <li>本サイトに対する不正アクセス・ハッキング等のサイバー攻撃がないこと。</li>
                <li>本サイト及びその内容が正確、完全、確実、最新であること又はウイルスその他の有害な要素を含んでいないこと</li>
              </ol>
            </li>
            <li>ユーザーは、本サイトの利用に起因又は関連して損害が生じた場合について、当社の責めに帰すべき事由がある場合に限り、当社に対し損害賠償を請求することができるものとします。また、ユーザーは、当社に故意又は重過失がある場合を除き、いかなる場合においても、（i）かかる損害賠償の対象となる損害が、当社の責に帰すべき事由に起因して現実に発生した、直接かつ通常の範囲の損害に限定されること、及び（ii）当社がユーザーに対して賠償する損害の累計額が、当社が本サイトに関連して当該ユーザーから受領したサイト利用料の合計額又は10,000円のいずれか低い金額を上限とすることに同意します。</li>
            <li>当社は、本サイト上の、又は本サイトを経由して得られる情報が完全、正確又は最新のものであることを何ら保証するものではありません。当社は、ユーザーがこれらの情報を使用又は依拠したことに関して、責任を負いません。</li>
          </ol>
        </section>
        <section>
          <h2>準拠法と裁判管轄</h2>
          <p>本利用規約は、日本法に準拠し、これによって解釈されます。本利用規約に起因又は関連して生じた全ての紛争は、名古屋地方裁判所を第一審の専属的合意管轄裁判所とするものとします。</p>
        </section>
        <section>
          <h2>問い合わせ先</h2>
          <p>本サイト又は本サービスに関する問い合わせは、以下の連絡先にお問い合わせください。</p>
          <p>株式会社オムニ<br>
          訪問支援マッチングサービスアネラ事務局<br>
          〒461-0005<br>
          名古屋市東区東桜1丁目13番3号　NHK名古屋放送センタービル12F<br>
          TEL：052-971-7653<br>
          FAX：052-971-7654<br>
          e-MAIL：contact@omni-anela.com</p>
        </section>
      </section>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import HeaderComponent from "./HeaderComponent";
import FooterComponent from "./FooterComponent";

export default {
  metaInfo: {
    title: "訪問支援マッチングサービスアネラ利用規約 | 訪問支援マッチングサービスアネラ - 訪問支援マッチングサービスアネラは全国でご利用いただける障がい児向け訪問型療育サービスです。お気軽にお問い合わせください。"
  },
  components: {
    HeaderComponent,
    FooterComponent
  }
}
</script>

<style lang="scss" scoped>
main {
  margin-bottom: 40px;
  padding: 10px;
  section {
    font-size: 14px;
    h1 {
      text-align: center;
      font-size: 18px;
    }
    section {
      counter-increment: count;
      h2 {
        font-size: 16px;
      }
      h2::before {
        content: counter(count) ".";
        display: inline-block;
        width: 1.5em;
        text-align: right;
      }
    }
  }
  @media (max-width: 575px) {
    ol {
      padding-left:1em;
    }
    li {
      margin: 0;
    }
  }
  @media (min-width: 576px) {
    section {
      h1 {
        font-size: 30px;
      }
      section {
        h2 {
          font-size: 26px;
        }
      }
    }
  }
  @media (min-width: 1220px) {
    padding: 10px calc(50% - 600px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TermsOfService.vue